import React, { Component } from "react";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import RentPrintArabic from "./RentPrintArabic";
import RentPrintKurdish from "./RentPrintKurdish";
import RentPrintEnglish from "./RentPrintEnglish";
import { View_Rent_Contract } from "../../../actions_agent/Invoice_action";
class RentPrint extends Component {
  componentDidMount() {
    this.props.View_Rent_Contract(
      this.props.match.params.id,
      this.props.match.params.index
    );
  }
  render() {
    const { lang, rent_invoice_obj } = this.props;
    return (
      <>
        {lang === "krd" ? (
          <RentPrintKurdish rent_invoice_obj={rent_invoice_obj} />
        ) : lang === "arb" ? (
          <RentPrintArabic rent_invoice_obj={rent_invoice_obj} />
        ) : (
          <RentPrintEnglish rent_invoice_obj={rent_invoice_obj} />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    rent_invoice_obj: state.Invoice_Reducer.rent_invoice_obj,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    change_Lang: (key) => dispatch(change_Lang(key)),
    View_Rent_Contract: (id, index) => dispatch(View_Rent_Contract(id, index)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RentPrint);
